// Helper functions for BusinessBreakdown.jsx

import {
  CATEGORY_1,
  CATEGORY_2,
  CATEGORY_TOTAL,
  WOSB,
  HUBZONE,
  SDVOSB,
  EDWOSB,
  VOSB,
  SMALL_BUSINESS,
  OTHER_THAN_SMALL,
  GROUP_TOTAL,
} from "../constants";

/**
 * @typedef {import("../jsdoc/BusinessSizeCount").BusinessSizeCount} BusinessSizeCount
 * @typedef {import("../jsdoc/GroupCount").GroupCount} GroupCount
 * @typedef {import("../jsdoc/GroupsData").GroupsData} GroupsData
 */

/**
 * Extracts the contractCount and contractHolderCount data from groupCounts array
 * @param {GroupCount[]} groupCounts
 * @returns {{contractCount: number, contractHolderCount: number}}
 */
export const getContractCounts = (groupCounts) => {
  const { contractCount, contractHolderCount } = groupCounts.find((group) => group.category === CATEGORY_TOTAL);
  return {
    contractCount,
    contractHolderCount,
  };
};

/**
 * Extracts CH and Contract counts from businessSizeCounts array
 * @param {BusinessSizeCount[]} businessSizeCounts
 * @returns {GroupsData}
 */
export const getGroupsData = (businessSizeCounts) => {
  const groupData = {
    [WOSB]: {},
    [HUBZONE]: {},
    [SDVOSB]: {},
    [EDWOSB]: {},
    [VOSB]: {},
    [SMALL_BUSINESS]: {},
    [OTHER_THAN_SMALL]: {},
    [GROUP_TOTAL]: {},
  };

  businessSizeCounts.forEach(({ category, businessSize, contractHolderCount, contractCount }) => {
    if (category === CATEGORY_1) {
      groupData[[businessSize]].chsA = contractHolderCount;
      groupData[[businessSize]].contractsA = contractCount;
    } else if (category === CATEGORY_2) {
      groupData[[businessSize]].chsB = contractHolderCount;
      groupData[[businessSize]].contractsB = contractCount;
    }
  });
  return groupData;
};
